import { ProjectDatesConstants } from "../../../../../../constants";
import { GetProjectDetailsResponse } from "../../../../../../service/publicquery";
import { convertDateToStringDDMMYYYY } from "../../../../../../utils";
import { Column, Divider, ReadonlyText, Row } from "../../../../../../widget";
import { useDatesSection } from "./useDatesSection";

interface DatesSectionProps {
  projectDetails: GetProjectDetailsResponse;
}

export const DatesSection = ({ projectDetails }: DatesSectionProps): JSX.Element => {
  const { projectDates } = useDatesSection({ projectDetails });

  return (
    <div className="PublicDatesSectionWrapper">
      <Row spacingV="ll">
        <Column span={6}>
          <h2>Dates</h2>
        </Column>
      </Row>
      <Row spacingV="ll">
        <Column span={5}>
          <ReadonlyText
            label="Registration date"
            value={
              projectDates?.design.registrationDate
                ? convertDateToStringDDMMYYYY(projectDates?.design.registrationDate)
                : "Not available"
            }
            noDataAvailable={!projectDates?.design.registrationDate}
            tooltipText={ProjectDatesConstants.DESIGN_REGISTRATION_DATE_TOOLTIP_TEXT}
            tooltipHeader=""
          />
        </Column>
        <Column span={5}>
          <ReadonlyText
            label="Implementation date"
            value={
              projectDates?.implementation.implementationDate
                ? convertDateToStringDDMMYYYY(projectDates?.implementation.implementationDate)
                : "Not available"
            }
            noDataAvailable={!projectDates?.implementation.implementationDate}
            tooltipText={ProjectDatesConstants.IMPLEMENTATION_IMPLEMENTATION_DATE_TOOLTIP_TEXT}
            tooltipHeader=""
          />
        </Column>
      </Row>
      <Row spacingV="xl">
        <Column span={5}>
          <ReadonlyText
            label="Start date"
            value={
              projectDates?.implementation.startDate
                ? convertDateToStringDDMMYYYY(projectDates?.implementation.startDate)
                : "Not available"
            }
            noDataAvailable={!projectDates?.implementation.startDate}
            tooltipText={ProjectDatesConstants.IMPLEMENTATION_START_DATE_TOOLTIP_TEXT}
            tooltipHeader=""
          />
        </Column>
        <Column span={5}>
          <ReadonlyText
            label="Project duration"
            value={projectDates?.duration.duration ?? "Not available"}
            noDataAvailable={!projectDates?.duration.duration}
            tooltipText={ProjectDatesConstants.IMPLEMENTATION_DURATION_TOOLTIP_TEXT}
            tooltipHeader=""
          />
        </Column>
      </Row>
      <Row spacingV="xl">
        <Column span={12}>
          <Divider type="horizontal" />
        </Column>
      </Row>
      <Row spacingV="ll">
        <Column span={6}>
          <h2>Monitoring</h2>
        </Column>
      </Row>
      <Row spacingV="ll">
        <Column span={5}>
          <ReadonlyText
            label="Validation date"
            value={
              projectDates?.implementation.validationDate
                ? convertDateToStringDDMMYYYY(projectDates?.implementation.validationDate)
                : "Not available"
            }
            noDataAvailable={!projectDates?.implementation.validationDate}
            tooltipText={ProjectDatesConstants.IMPLEMENTATION_FIRST_ASSESSMENT_DATE_TOOLTIP_TEXT}
            tooltipHeader=""
          />
        </Column>
        <Column span={5}>
          <ReadonlyText
            label="Second assessment date"
            value={
              projectDates?.ongoingMonitoring.cycles[0]?.assessmentDate
                ? convertDateToStringDDMMYYYY(projectDates?.ongoingMonitoring.cycles[0].assessmentDate)
                : "Not available"
            }
            noDataAvailable={!projectDates?.ongoingMonitoring.cycles[0]?.assessmentDate}
            tooltipText={ProjectDatesConstants.ONGOING_MONITORING_SECOND_ASSESSMENT_DATE_TOOLTIP_TEXT}
            tooltipHeader=""
          />
        </Column>
      </Row>
      <Row>
        <Column span={5}>
          <ReadonlyText
            label="Final assessment date"
            value={
              projectDates?.ongoingMonitoring.finalAssessmentDate
                ? convertDateToStringDDMMYYYY(projectDates?.ongoingMonitoring.finalAssessmentDate)
                : "Not available"
            }
            noDataAvailable={!projectDates?.ongoingMonitoring.finalAssessmentDate}
            tooltipText={ProjectDatesConstants.ONGOING_MONITORING_FINAL_ASSESSMENT_DATE_TOOLTIP_TEXT}
            tooltipHeader=""
          />
        </Column>
        <Column span={5}>
          <ReadonlyText
            label="Subsequent frequency"
            value={projectDates?.ongoingMonitoring.subsequentFrequency ?? "Not available"}
            noDataAvailable={!projectDates?.ongoingMonitoring.subsequentFrequency}
            tooltipText={ProjectDatesConstants.ONGOING_MONITORING_SUBSEQUENT_FREQUENCY_TOOLTIP_TEXT}
            tooltipHeader=""
          />
        </Column>
      </Row>
    </div>
  );
};
